import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';

export function SecurityBadge() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-2.5 py-3">
      <div className="flex items-center gap-5 text-muted-foreground/70">
        <div className="flex items-center gap-1.5">
          <Lock className="w-3.5 h-3.5 text-primary/50" />
          <span className="text-[11px] font-medium">{t('security.sslEncrypted')}</span>
        </div>
      </div>

      {/*     <div className="flex items-center gap-1.5 text-muted-foreground/50">
        <span className="text-[11px]">{t('security.securedBy')}</span>
        <span className="text-[11px] font-bold tracking-wide bg-gradient-to-r from-[#500B4D] to-[#DC2A4A] bg-clip-text text-transparent">
          Ikawaari
        </span>
      </div> */}
    </div>
  );
}
